export default __webpack_public_path__ + "static/media/personreview.7156772d.jpg";